/* Reveal BOTA's already-selected extension category on initial collection load.
 * Selection, products, URL, sorting and later shopper interactions remain BOTA-owned.
 * Remove this asset and its layout include once BOTA handles initial tab selection.
 */
(() => {
  'use strict';
  if (window.__bhBotaCategoryTab) return;
  window.__bhBotaCategoryTab = true;

  const primaryGroups = new Set(['Instant (DIY)', 'Semi-Permanent (Salon-Installed)']);
  let stopped = false;
  let host;
  let shadow;
  let observer;
  let discoveryTimer;
  let expiryTimer;

  function stop() {
    stopped = true;
    clearInterval(discoveryTimer);
    clearTimeout(expiryTimer);
    if (observer) observer.disconnect();
    if (host) {
      host.removeEventListener('pointerdown', onInteraction, true);
      host.removeEventListener('keydown', onInteraction, true);
    }
    window.removeEventListener('popstate', stop);
    window.removeEventListener('pagehide', stop);
  }

  function onInteraction(event) {
    if (event.isTrusted) stop();
  }

  function revealSelectedGroup() {
    if (stopped || !shadow) return;
    const groupButtons = Array.from(shadow.querySelectorAll('button')).filter(button => {
      const label = Array.from(button.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent).join('').trim();
      return primaryGroups.has(label) && !button.disabled && button.getClientRects().length;
    });
    if (groupButtons.length !== 2) return;
    const candidates = groupButtons.filter(button =>
      Array.from(button.querySelectorAll('span')).some(span => /^[1-9]\d*$/.test(span.textContent.trim()))
    );
    // Ambiguous or absent native selection must not impose a category.
    if (candidates.length !== 1) return;
    const target = candidates[0];
    const alreadyActive = target.classList.contains('border-b-2');
    // An initially active/default tab may precede BOTA's final selection.
    if (alreadyActive) return;
    stop();
    target.click();
  }

  function discover() {
    if (stopped) return;
    const root = document.getElementById('bota-filter-react-root');
    if (!root) return;
    if (!host) {
      let config;
      try { config = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (_) { stop(); return; }
      if (!config.collection || !config.collection.handle) { stop(); return; }
      host = root;
      host.addEventListener('pointerdown', onInteraction, true);
      host.addEventListener('keydown', onInteraction, true);
    }
    if (!host.shadowRoot) return;
    shadow = host.shadowRoot;
    clearInterval(discoveryTimer);
    observer = new MutationObserver(revealSelectedGroup);
    observer.observe(shadow, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    revealSelectedGroup();
  }

  window.addEventListener('popstate', stop);
  window.addEventListener('pagehide', stop);
  // This is a cleanup deadline, not a delayed tab change.
  expiryTimer = setTimeout(stop, 10000);
  discoveryTimer = setInterval(discover, 100);
  discover();
})();
